import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Outlet,
  Link,
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { adminLogin, adminLogout, changePassword } from "../services/auth.service";
import { loginSuccess, logout } from "../redux/actions/Actions";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

export default function Site() {
  const { rememberedUsername, rememberedPassword, token } = useSelector(
    (state) => state?.auth
  );
  const { register, handleSubmit, getValues, formState: { errors }, reset } = useForm();
  const [isLoading2, setIsLoading2] = useState(false);
  const location = useLocation();
  const activePath = location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { pathname } = useLocation();
  const tabsRef = useRef({});

 
  const handleSubmitChangePassword = async (item) => {
    setIsLoading2(true);
  
    try {
      const data = {
        old_password: item.old_password,
        new_password: item.new_password,
        confirm_password: item.confirm_password,
      };
  
      // Make API call to change password
      const res = await changePassword(token, data); // Replace with your API function
  
      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire(
          "Password Changed",
          "Your password has been successfully updated.",
          "success"
        ).then(()=>{
          document.getElementById("closeChangePasswordModalTitle").click();
        });
        // navigate("/dashboard"); // Redirect after successful password change
      } else if (res && res.status >= 400 && res.status < 500) {
        const errorMessage =
          res?.data?.error || "Invalid data. Please verify and try again.";
        Swal.fire("Change Password Failed!", errorMessage, "error");
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected server error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during password change:", error);
      Swal.fire(
        "Error",
        "Unable to complete the password change process. Please check your connection and try again.",
        "error"
      );
    } finally {
      setIsLoading2(false);
      reset();
    }
  };
  

  const signIn = async () => {
    try {
      const data = {
        email: rememberedUsername,
        password: rememberedPassword,
        role: "Admin",
      };

      const res = await adminLogin(data);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res);

        const token = res.data.token;
        dispatch(loginSuccess(token));
      } else if (res && res.status >= 400 && res.status < 500) {
        const errorMessage =
          res?.data?.error || "Invalid credentials. Please try again.";
        console.log(errorMessage);
      } else {
        // console.log(res);
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top
    if (!token) {
      navigate("/");
    }
    // if (rememberedUsername) {
    //   signIn();
    // }
  }, [pathname]);

  const [ordersListVisible, setOrdersListVisible] = useState(false);
  const [agentListVisible, setAgentListVisible] = useState(false);
  const [retailerListVisible, setRetailerListVisible] = useState(false);
  const [showList, setShowList] = useState(false);
  const [title, setTitle] = useState("Dashboard");
  const [retailerInfo, setRetailerInfo] = useState({
    retailerName: "",
    shopName: "",
  });

  const handleLogout = async () => {
    dispatch(logout());
    navigate("/");

    // try {
    //   const data = {
    //     email : rememberedUsername
    //   }

    //   const res = await adminLogout(token, data);

    //   if (res && res.status >= 200 && res.status < 300) {
    //     console.log(res?.data)
    //   }
    //   //  else {
    //   //   Swal.fire(
    //   //     "Logout Failed",
    //   //     res?.data?.message || "Unable to log out. Please try again later.",
    //   //     "error"
    //   //   );
    //   // }
    // } catch (error) {
    //   console.error("Error during logout:", error);
    //   // Swal.fire(
    //   //   "Error",
    //   //   "An unexpected error occurred. Please check your connection and try again.",
    //   //   "error"
    //   // );
    // }
  };

  const toggleListVisibility = () => {
    // Only toggle the list if we're not in "/orders/" route
    if (!activePath.startsWith("/orders/")) {
      // setShowList((prev) => !prev);
    }
  };

  // useEffect(() => {
  //   // Show the list if the path starts with "/orders/", else hide it
  //   if (activePath.startsWith("/orders")) {
  //     setShowList(true);
  //   } else {
  //     setShowList(false);
  //   }
  // }, [activePath]);

  useEffect(() => {
    if (activePath.startsWith("/orders")) {
      if (activePath.startsWith("/orders/placed")) {
        setTitle("Order-Placed");
      } else if (activePath.startsWith("/orders/confirmed")) {
        setTitle("Order-Confirmed");
      } else if (activePath.startsWith("/orders/shipped")) {
        setTitle("Order-Shipped");
      } else if (activePath.startsWith("/orders/delivered")) {
        setTitle("Order-Delivered");
      } else if (activePath.startsWith("/orders/cancelled")) {
        setTitle("Order-Cancelled");
      } else {
        setTitle("Orders");
      }
      setOrdersListVisible(true);
    } else if (activePath.startsWith("/retailer/orders")) {
      setTitle("Retailer-Orders");
      setOrdersListVisible(true);
      // setRetailerInfo({
      //   retailerName: "James Sullivan",
      //   shopName: "Sullivan's Shop",
      // });
    } else if (activePath.startsWith("/brands")) {
      setTitle("Brands");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/main-categories")) {
      setTitle("Main Category");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/sub-categories")) {
      setTitle("Sub Category");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/products/designs")) {
      setTitle("Designs");
      setShowList(false);
    } else if (activePath.startsWith("/products")) {
      setTitle("Products");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/rate-diary")) {
      setTitle("Rate Diary");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/place-order")) {
      setTitle("Place Order");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/coupons")) {
      setTitle("Coupons");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/agent")) {
      setTitle("Agent");
      setAgentListVisible(true);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/retailer")) {
      setTitle("Retailer");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(true);
    } else if (activePath.startsWith("/retailer/credit-wallet")) {
      setTitle("Wallet");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(true);
    } else if (activePath.startsWith("/agent/agent-retailer")) {
      setTitle("Agent-Retailer");
      setOrdersListVisible(false);
      setAgentListVisible(true);
      setRetailerListVisible(false);
    } else if (activePath.startsWith("/setup")) {
      setTitle("Setup");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else if (activePath === "/dashboard") {
      setTitle("Dashboard");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    } else {
      setTitle("");
      setOrdersListVisible(false);
      setAgentListVisible(false);
      setRetailerListVisible(false);
    }

    // Scroll to active tab
    const activeTabRef = tabsRef.current[activePath];
    if (activeTabRef) {
      activeTabRef.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [activePath]);

  return (
    <div id="main-wrapper" className="show">
      {/*  id="main-wrapper" */}
      {/* <!--**********************************
            Nav header start
        ***********************************--> */}
      <div className="nav-header">
        <Link to="/dashboard" className="brand-logo">
          <img
            style={{ background: "white", borderRadius: "100px" }}
            className="logo-abbr"
            src="/assets/images/kidskart/kk-logo-5.png"
            alt=""
          />
          <img
            className="logo-compact"
            src="/assets/images/kidskart/logo-5.png"
            alt=""
          />
          <img
            className="brand-title"
            src="/assets/images/kidskart/logo-5.png"
            alt=""
          />
        </Link>

        <div className="nav-control">
          <div className="hamburger">
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
      </div>
      {/* <!--**********************************
            Nav header end
        ***********************************--> */}

      {/* <!--**********************************
            Header start
        ***********************************--> */}
      <div className="header">
        <div className="header-content">
          <nav className="navbar navbar-expand">
            <div className="collapse navbar-collapse justify-content-between">
              <div className="header-left">
                <div className="dashboard_bar">
                  {title}
                  {activePath.startsWith("/retailer/orders") && (
                    <span
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        color: "#888",
                      }}
                    >
                      {/* - {retailerInfo.retailerName} ({retailerInfo.shopName}) */}
                    </span>
                  )}
                  {(activePath.startsWith("/agent/agent-retailer") ||
                    activePath.startsWith("/agent/agent-add-retailer") ||
                    activePath.startsWith("/agent/agent-details-retailer") ||
                    activePath.startsWith("/agent/agent-update-retailer")) && (
                    <span
                      style={{
                        fontSize: "28px",
                        fontWeight: "600",
                        color: "#000",
                      }}
                    >
                      -Retailer
                    </span>
                  )}
                  {activePath.startsWith("/agent/agent-order") && (
                    <span
                      style={{
                        fontSize: "28px",
                        fontWeightL: "600",
                        color: "#000",
                      }}
                    >
                      -Orders
                    </span>
                  )}
                  {activePath.startsWith("/products/designs") && (
                    <span
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        color: "#888",
                      }}
                    >
                      {/* - FULL SLEEVE DUNGAREE (Boys) */}
                    </span>
                  )}
                  {(activePath.startsWith("/retailer/credit-wallet") ||
                    activePath.startsWith("/retailer/wallet-add") ||
                    activePath.startsWith("/retailer/wallet-update") ||
                    activePath.startsWith("/retailer/wallet-history")) && (
                    <span
                      style={{
                        fontSize: "28px",
                        fontWeightL: "600",
                        color: "#000",
                      }}
                    >
                      -Wallet
                    </span>
                  )}
                </div>
              </div>

              <ul className="navbar-nav header-right">
                <li className="nav-item dropdown header-profile">
                  <Link
                    className="nav-link"
                    to="#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    <div className="header-info">
                      {/* <small>Good Morning</small> */}
                      <span>Hello Admin!</span>
                    </div>
                    <img
                      src="/assets/images/profile/user-profile.png"
                      width="20"
                      alt=""
                    />
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end">
                    <div
                      className="dropdown-item ai-icon"
                      role="button"
                      style={{ cursor: "pointer" }}
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModal"
                    >
                      <svg
                        id="icon-user1"
                        xmlns="http://www.w3.org/2000/svg"
                        class="text-primary"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                      <span class="ms-2">Change Passoword</span>
                    </div>

                    <div
                      className="dropdown-item ai-icon"
                      onClick={() => handleLogout()}
                      role="button"
                      style={{ cursor: "pointer" }}
                    >
                      <svg
                        id="icon-logout"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-danger"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                      </svg>
                      <span className="ms-2">Logout </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      {/* <!--**********************************
            Header end ti-comment-alt
        ***********************************--> */}

      {/* <!--**********************************
            Sidebar start
        ***********************************--> */}

      {/* <!-- Change Password Modal --> */}
      <div
        className="modal fade"
        id="changePasswordModal"
        tabIndex="-1"
        aria-labelledby="changePasswordModalTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="changePasswordModalTitle">
                Change Password
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeChangePasswordModalTitle"
              ></button>
            </div>
            <form
              id="changePasswordForm"
              onSubmit={handleSubmit(handleSubmitChangePassword)}
            >
              <div className="modal-body">
                <p className="fs-6 mb-4 fw-bold">
                  Update your account password below.
                </p>
                <div className="container">
                  {/* <!-- Current Password Input --> */}
                  <div className="row mb-4">
                  <div className="d-flex col-sm-5 col-form-label p-0">
                          <label className="form-label">Current Password</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                    <div className="col-sm-7 p-0">
                      <input
                        {...register("old_password", {
                          required: "Current password is required",
                        })}
                        type="password"
                        className="form-control"
                        placeholder="Enter current password"
                      />
                      {errors.old_password && (
                        <p className="error">
                          {errors.old_password.message}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* <!-- New Password Input --> */}
                  <div className="row mb-4">
                  
                    <div className="d-flex col-sm-5 col-form-label p-0">
                          <label className="form-label">New Password</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                    <div className="col-sm-7 p-0">
                      <input
                        {...register("new_password", {
                          required: "New password is required",
                        })}
                        type="password"
                        className="form-control"
                        placeholder="Enter new password"
                      />
                      {errors.new_password && (
                        <p className="error">{errors.new_password.message}</p>
                      )}
                    </div>
                  </div>

                  {/* <!-- Confirm Password Input --> */}
                  <div className="row mb-4">
                  <div className="d-flex col-sm-5 col-form-label p-0">
                          <label className="form-label">Confirm Password</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                    <div className="col-sm-7 p-0">
                      <input
                        {...register("confirm_password", {
                          required: "Please confirm your password",
                          validate: (value) =>
                            value === getValues("new_password") ||
                            "Passwords do not match",
                        })}
                        type="password"
                        className="form-control"
                        placeholder="Confirm new password"
                      />
                      {errors.confirm_password && (
                        <p className="error">
                          {errors.confirm_password.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {!isLoading2 ? (
                  <button type="submit" className="btn btn-primary col-12">
                    Change Password
                  </button>
                ) : (
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-primary col-12"
                      disabled
                    >
                      Changing Password
                    </button>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <!-- End Change Password Modal --> */}

      <div className="deznav">
        <div className="deznav-scroll mm-active">
          <ul className="metismenu mm-show" id="menu">
            {/* Dashboard Link */}
            <li
              ref={(el) => (tabsRef.current["/dashboard"] = el)}
              className={
                activePath === "/dashboard" ? "mt-0 mm-active" : "mt-0"
              }
            >
              <Link className="ai-icon" to="/dashboard">
                <i className="flaticon-dashboard-8"></i>
                <span className="nav-text">Dashboard</span>
              </Link>
            </li>

            <li
              ref={(el) => (tabsRef.current["/orders"] = el)}
              className={
                activePath.startsWith("/orders") && ordersListVisible
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                aria-expanded={ordersListVisible}
                onClick={(e) => {
                  setOrdersListVisible(!ordersListVisible);
                  e.preventDefault();
                  navigate("/orders");
                }}
              >
                <i className="flaticon-newsletter"></i>
                <span className="nav-text">Orders</span>
              </Link>
              <ul
                aria-expanded={ordersListVisible}
                className={`mm-collapse ${
                  ordersListVisible ? "mm-show" : "d-none"
                }`}
              >
                <li>
                  <Link to="/orders/placed">Placed</Link>
                </li>
                <li>
                  <Link to="/orders/confirmed">Confirmed</Link>
                </li>
                <li>
                  <Link to="/orders/shipped">Shipped</Link>
                </li>
                <li>
                  <Link to="/orders/delivered">Delivered</Link>
                </li>
                <li>
                  <Link to="/orders/cancelled">Cancelled</Link>
                </li>
              </ul>
            </li>

            {/* Other Links */}
            <li
              ref={(el) => (tabsRef.current["/brands"] = el)}
              className={activePath.startsWith("/brands") ? "mm-active" : ""}
            >
              <Link className="ai-icon" to="/brands">
                <i className="flaticon-star"></i>
                <span className="nav-text">Brands</span>
              </Link>
            </li>
            <li
              ref={(el) => (tabsRef.current["/main-categories"] = el)}
              className={
                activePath.startsWith("/main-categories") ? "mm-active" : ""
              }
            >
              <Link className="ai-icon" to="/main-categories">
                <i className="flaticon-layout"></i>
                <span className="nav-text">Main Category</span>
              </Link>
            </li>
            <li
              ref={(el) => (tabsRef.current["/sub-categories"] = el)}
              className={
                activePath.startsWith("/sub-categories") ? "mm-active" : ""
              }
            >
              <Link className="ai-icon" to="/sub-categories">
                <i className="flaticon-dashboard"></i>
                <span className="nav-text">Sub Category</span>
              </Link>
            </li>
            <li
              ref={(el) => (tabsRef.current["/products"] = el)}
              className={activePath.startsWith("/products") ? "mm-active" : ""}
            >
              <Link className="ai-icon" to="/products">
                <i className="flaticon-smartphone"></i>

                <span className="nav-text">Products</span>
              </Link>
            </li>
            <li
              ref={(el) => (tabsRef.current["/rate-diary"] = el)}
              className={
                activePath.startsWith("/rate-diary") ? "mm-active" : ""
              }
            >
              <Link className="ai-icon" to="/rate-diary/add">
                <i className="flaticon-form-1"></i>
                <span className="nav-text">Rate Diary</span>
              </Link>
            </li>
            <li
              ref={(el) => (tabsRef.current["/place-order"] = el)}
              className={
                activePath.startsWith("/place-order") ? "mm-active" : ""
              }
            >
              <Link className="ai-icon" to="/place-order">
                <i className="flaticon-smartphone"></i>
                <span className="nav-text">Place Order</span>
              </Link>
            </li>
            <li
              ref={(el) => (tabsRef.current["/coupons"] = el)}
              className={activePath.startsWith("/coupons") ? "mm-active" : ""}
            >
              <Link className="ai-icon" to="/coupons">
                <i className="flaticon-discount"></i>
                <span className="nav-text">Coupons</span>
              </Link>
            </li>

            <li
              ref={(el) => (tabsRef.current["/agent"] = el)}
              className={
                activePath.startsWith("/agent") && agentListVisible
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                aria-expanded={agentListVisible}
                onClick={(e) => {
                  setAgentListVisible(!agentListVisible);
                  e.preventDefault();
                  navigate("/agent");
                }}
              >
                <i className="flaticon-newsletter"></i>
                <span className="nav-text">Agent</span>
              </Link>
              <ul
                aria-expanded={agentListVisible}
                className={`mm-collapse ${
                  agentListVisible ? "mm-show" : "d-none"
                }`}
              >
                <li>
                  <Link to="/agent/agent-order">Orders</Link>
                </li>
                <li>
                  <Link to="/agent/agent-retailer">Retailer</Link>
                </li>
              </ul>
            </li>

            {/* retailer Link with Submenu */}

            <li
              ref={(el) => (tabsRef.current["/retailer"] = el)}
              className={
                activePath.startsWith("/retailer") && retailerListVisible
                  ? "mm-active"
                  : ""
              }
            >
              <Link
                className="has-arrow ai-icon"
                to="#"
                aria-expanded={retailerListVisible}
                onClick={(e) => {
                  setRetailerListVisible(!retailerListVisible);
                  e.preventDefault();
                  navigate("/retailer");
                }}
              >
                <i className="flaticon-form"></i>
                <span className="nav-text">Retailer</span>
              </Link>
              <ul
                aria-expanded={retailerListVisible}
                className={`mm-collapse ${
                  retailerListVisible ? "mm-show" : "d-none"
                }`}
              >
                <li>
                  <Link to="retailer/credit-wallet">Credit Wallet</Link>
                </li>
              </ul>
            </li>

            <li
              ref={(el) => (tabsRef.current["/setup"] = el)}
              className={activePath.startsWith("/setup") ? "mm-active" : ""}
            >
              <Link className="ai-icon" to="/setup">
                <i className="flaticon-content-writing"></i>
                <span className="nav-text">Setup</span>
              </Link>
            </li>
            <li
              className={activePath === "/" ? "mm-active" : ""}
              onClick={() => handleLogout()}
            >
              <Link className="ai-icon" to="#">
                <i className="flaticon-enter"></i>
                <span className="nav-text">Logout</span>
              </Link>
            </li>
            <li className="my-5"></li>
            <li className="my-5"></li>
          </ul>
        </div>
      </div>

      {/* <!--**********************************
            Sidebar end
        ***********************************--> */}

      <Outlet context={{ toggleListVisibility }} />

      {/* <!--**********************************
            Footer start
        ***********************************--> */}
      <div className="footer">
        <div className="copyright mt-5">
          <p className="mt-5">
            {/* Copyright © 2025 <strong>KidsKart Admin Dashboard. </strong>
            All Rights Reserved */}
            KidsKart Powered By <strong>BHARAT KUMAR MOTILAL & CO</strong>.
          </p>
        </div>
      </div>
      {/* <!--**********************************
            Footer end
        ***********************************--> */}
    </div>
  );
}
